import { GATE, gateDecision } from '@/composables/app-start/gate';

export const showOnboarding = ({ user, account, showCompanyInfo = false }) => {
  const gate = gateDecision({ user, account });
  if ([GATE.PROFILE, GATE.ACCOUNT].includes(gate)) {
    return true;
  }
  return showCompanyInfo && gate === GATE.ACTIVATE;
};
